import { SYSTEM_APP_ID } from "./constants";

const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
};
const appSettingsMapper = (appSettings) => {
  const appSettingsMap = appSettings.map((app) => {
    return {
      appDisplayName: toTitleCase(app?.displayName),
      appSettingsUrl:
        app?.settingsUrl && !app?.settingsUrl.startsWith("/")
          ? `/${app?.settingsUrl}`
          : app?.settingsUrl,
      icon:
        app?.icon ||
        "https://cdn.getos1.com/0ebccabf-34b9-4aaa-954d-e985da6fea56-solution-default.svg",
      description: app?.description,
    };
  });

  return appSettingsMap;
};
export const mapSettingsResponse = (subscriptionSettings) => {
  let solutionSettings = [];
  const solutionMap = new Map();
  if (subscriptionSettings?.foundation?.length > 0) {
    const foundationalAppSetttings = appSettingsMapper(
      subscriptionSettings?.foundation
    );
    solutionSettings.push({
      id: SYSTEM_APP_ID,
      settingsLabel: "System Apps",
      settingsIcon:
        "https://cdn.getos1.com/2914531d-dc99-41ca-84c7-86e1188595e5-svgviewer-output-(1).svg",
      appSettings: foundationalAppSetttings || [],
    });
  } else {
    solutionSettings.push({
      id: SYSTEM_APP_ID,
      settingsLabel: "System Apps",
      settingsIcon:
        "https://cdn.getos1.com/2914531d-dc99-41ca-84c7-86e1188595e5-svgviewer-output-(1).svg",
      appSettings: [],
    });
  }

  subscriptionSettings?.solutions?.map((solution) => {
    if (solution?.settings?.length > 0) {
      if (solutionMap.has(solution?.solutionId)) {
        const existingSolution = solutionMap.get(solution?.solutionId);
        const solutionAppSettings = appSettingsMapper(solution.settings);
        const existingAppSettings = existingSolution?.appSettings || [];

        // Create a set to track unique appDisplayNames
        const uniqueAppDisplayNames = new Set(
          existingAppSettings.map((element) => element.appDisplayName)
        );

        // Merge arrays without duplicates
        const existingSolutionResults = [
          ...existingAppSettings,
          ...solutionAppSettings.filter(
            (element) => !uniqueAppDisplayNames.has(element.appDisplayName)
          ),
        ];

        existingSolution.appSettings = existingSolutionResults;

        solutionMap.set(solution?.solutionId, existingSolution);
      } else {
        solutionMap.set(solution?.solutionId, {
          id: solution?.solutionId,
          settingsLabel: `${toTitleCase(solution?.displayName)} Apps`,
          appSettings: appSettingsMapper(solution.settings),
          settingsIcon: solution?.icon,
        });
      }
    }
  });

  solutionSettings = solutionSettings.concat(Array.from(solutionMap.values()));

  return solutionSettings;
};
